import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ApiService from "../api/ApiService";
import "../css/RecordingOfScores.css";
import "../css/app.css";
import "../css/Liveranking.css";

import AppContext from "../context/AppContext";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import "bootstrap-icons/font/bootstrap-icons.css";
import * as XLSX from "xlsx";
import { Table } from "react-bootstrap";
Modal.setAppElement("#root");

const LiveRankingData = () => {
  const { t, i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState("en");

  const [liveRankingData, setDataFromAllLiveRanking] = useState([]);
  const [liveRankingDataByUserId, setDataFromAllLiveRankinguserId] = useState(
    []
  );
  const [liveRankingDataZoneWiseN, setDataFromDBZoneWise] = useState([]);
  const [liveRankingDataTempleWiseN, setDataFromDBTempleWise] = useState([]);
  const currentYear = new Date().getFullYear();
  const [financialYearArray, setFinancialYearFromDB] = useState([]);
  // console.log("financialYearArray", financialYearArray);
  const [selectedFinancialYear, setSelectedFinancialYear] =
    useState(currentYear);

  const [financialAllData, setFinancialAllData] = useState([]);

  const [financialAndEventsAllData, setFinancialandEventsAllData] = useState(
    []
  );
  const [financialAndEventsZoneAllData, setFinancialandEventsZoneAllData] =
    useState([]);
  const [financialAndEventsTempleAllData, setFinancialandEventsTempleAllData] =
    useState([]);
  const [
    financialAndEventsBookWiseAllData,
    setFinancialandEventsBookWiseAllData,
  ] = useState([]);

  const [financialAndEventsStateAllData, setFinancialandEventsStateAllData] =
    useState([]);

  const [
    financialAndEventsSelectedZoneAllData,
    setFinancialandEventsSelectedZoneAllData,
  ] = useState([]);

  const [
    financialAndEventsSelectedTempleAllData,
    setFinancialandEventsSelectedTempleAllData,
  ] = useState([]);
  const [
    financialAndEventsSelectedStateAllData,
    setFinancialandEventsSelectedStateAllData,
  ] = useState([]);
  const [TempleWiseDataBasedonFEZ, setTempleWiseDataBasedonFEZ] = useState([]);
  const [allDataBookWiseWithZone, setAllDataBookWiseWithZone] = useState([]);
  const [
    allDataBookWiseWithZoneandTemple,
    setAllDataBookWiseWithZoneandTemple,
  ] = useState([]);
  const [allDataFYECandZone, setAllDataWithFYECandZone] = useState([]);

  const [searchQuery, setSearchQuery] = useState({
    particular: "",
    category: "",
    zone: "",
  });

  // console.log("allDataFYECandZone", allDataFYECandZone);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [filterBy, setFilterBy] = useState("");
  // const [zoneWise, setZonewise] = useState(""); // Added state for filter by selection
  // Added state for filter by selection
  const [selectedEvent, setSelectedEvent] = useState("Regular Update");
  const [userScoreData, setUserScoreData] = useState({});
  const [category, setCategory] = useState("");
  const [categoryandzone, setZonetTemple] = useState("");
  // console.log("categoryandzone", categoryandzone);

  const [templecategory, setTempleCategory] = useState("");
  const [bookwisezone, setBookWiseZones] = useState("");
  const [bookwisetemple, setBookWiseTemple] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedTemple, setSelectedTemple] = useState("");
  const [comparisonData, setComparisonData] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdowns, setShowDropdowns] = useState(false);
  const [selectedTemples, setSelectedTemples] = useState([
    "SELECT Temple",
    "",
    "",
    "",
  ]);
  const [states, setStates] = useState("");
  const [zone, setZones] = useState("");
  const [isSubZone, setIsSubZone] = useState(false);
  const { user } = React.useContext(AppContext);
  // Code for Search Logic Start

  const [searchVisibleCat, setSearchVisibleCat] = useState(false);
  const [searchVisiblePart, setSearchVisiblePart] = useState(false);

  const [searchVisibleZone, setSearchVisibleZone] = useState(false);

  const [searchTextTemple, setSearchTextTemple] = useState("");
  const [searchTextTempleName, setSearchTextTempleName] = useState("");
  const [searchTextZone, setSearchTextZone] = useState("");

  const handleHeaderClickCat = () => {
    setSearchVisibleCat((prev) => {
      const newState = !prev;
      if (newState) {
        setSearchVisiblePart(false);
        setSearchVisibleZone(false);
      }
      return newState;
    });
  };

  const handleHeaderClickPart = () => {
    setSearchVisiblePart((prev) => {
      const newState = !prev;
      if (newState) {
        setSearchVisibleCat(false);
        setSearchVisibleZone(false);
      }
      return newState;
    });
  };

  const handleHeaderClickZone = () => {
    setSearchVisibleZone((prev) => {
      const newState = !prev;
      if (newState) {
        setSearchVisiblePart(false);
        setSearchVisibleCat(false);
      }
      return newState;
    });
  };

  const handleSearchChangeTemple = (e) => {
    setSearchTextTemple(e.target.value);
  };

  const handleSearchChangeTempleName = (e) => {
    setSearchTextTempleName(e.target.value);
  };

  const handleSearchChangeZone = (e) => {
    setSearchTextZone(e.target.value);
  };

  const filteredDataForSearch = (
    selectedEvent ? financialAndEventsAllData : financialAllData
  ).filter(
    (row) =>
      row?.temple?.toLowerCase().includes(searchTextTemple.toLowerCase()) &&
      row.temple_name
        .toLowerCase()
        .includes(searchTextTempleName.toLowerCase()) &&
      row.zone.toLowerCase().includes(searchTextZone.toLowerCase())
  );

  const templeCategories = [
    { id: "BT", name: "Big Temple" },
    { id: "MT", name: "Medium Temple" },
    { id: "ST", name: "Small Temple" },
    { id: "PC", name: "Preaching Centre" },
    { id: "EC", name: "Extension Centre" },
    { id: "OP", name: "Outpost" },
  ];
  const abbreviationMapping = {
    BT: "Big Temple",
    ST: "Small Temple",
    MT: "Medium Temple",
    OP: "Outpost",
    PC: "Preaching Centre",
    EC: "Extension Centre",
  };
  const bookIdMapping = {
    MahabigBooks: "Mahabig Books",
    SrimadBhagavatamSet: "Srimad Bhagavatam Set",
    "1 Year BTG Subscription-1": "1 Year BTG Subscription-English",
    MediumBooks: "Medium Books",
    BigBooks: "Big Books",
    SmallBooks: "Small Books",
    SrilaPrabhupadaLilamrita: "Srila Prabhupada Lilamrita",
    "1 Year BTG Subscription-2": "1 Year BTG Subscription-Non English",
    ChaitanyaCharitamritaSet: "Chaitanya Charitamrita Set",
    Magazines: "Magazines",
  };

  const categories = [
    "Big Temple",
    "Medium Temple",
    "Small Temple",
    "Preaching Centre",
    "Extension Centre",
    "Outpost",
  ];
  const zones = ["East Zone", "West Zone", "North Zone", "South Zone"];
  const statesOfIndia = [
    "Andaman & Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra & Nagar Haveli",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Ladakh",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];
  // const [dataArrays, setDataArrays] = useState([]);
  const [dataArrays, setDataArrays] = useState([[], [], [], []]);

  const labels = [
    "Temple Name",
    "Zone",
    "Category",
    "All India Ranking",
    "Zone Ranking",
    "Category Ranking",
    "State Ranking",
    "Points",
    "Harinaam Sankirtan Count",
    "Chaitanya Charitamrita Set",
    "Srimad Bhagavatam Set",
    "Mahabig Books",
    "Big Books",
    "Medium Books",
    "Small Books",
    "Srila Prabhupada Lilamrita",
    "Magazines",
    "1 Year BTG Subscription-English",
    "1 Year BTG Subscription-Non English",
    // "Pledged covered"
  ];
  const labelsMap = {
    "Bhadra Purnima": [
      "Zone",
      "Category",
      "All India Ranking",
      "Zone Ranking",
      "Category Ranking",
      "State Ranking",
      "Points",
      "Harinaam Sankirtan Count",
      "",
      "Srimad Bhagavatam Set",
    ],
    "Chaitanya Charitamrita": [
      "Zone",
      "Category",
      "All India Ranking",
      "Zone Ranking",
      "Category Ranking",
      "State Ranking",
      "Points",
      "Harinaam Sankirtan Count",
      "Chaitanya Charitamrita Set",
    ],
    "Regular Update": labels,
    "Gita Marathon": labels,
    // Add more events here if needed
  };

  const numRows = 8; // Fixed number of rows for the table
  const numCols = 4; // Fixed number of columns for the table
  const formatDate = (dateString) => {
    if (!dateString) return ""; // Handle cases where date is not provided

    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Get day and pad with zero if needed
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month (0-based) and pad with zero
    const year = date.getFullYear(); // Get full year

    return `${day}-${month}-${year}`; // Format to DD-MM-YYYY
  };

  const getAllLiveDownload = () => {
    // Map the financialAllData to only include the necessary fields and rename them
    let filteredData;

    // Check if both selectedFinancialYear and selectedEvent are set
    if (
      selectedFinancialYear &&
      selectedEvent &&
      filterBy !== "state" &&
      filterBy !== "temple" &&
      filterBy !== "zone" &&
      filterBy !== "bookwise" &&
      !zone &&
      !states &&
      !categoryandzone
    ) {
      filteredData = financialAndEventsAllData.map((item, index) => ({
        Ranking: index + 1,
        Particular: item.temple_name,
        Category: item.temple,
        Zone: item.zone,
        "Harinaam Sankirtan Count": Math.ceil(item.no_of_book_distributed), // Round up the Harinaam Sankirtan Count
      }));
    } else if (!templecategory && zone && !categoryandzone) {
      filteredData = financialAndEventsSelectedZoneAllData.map(
        (item, index) => ({
          Ranking: index + 1,
          Particular: item.temple_name,
          Category: item.temple,
          Zone: item.zone,
          "Harinaam Sankirtan Count": Math.ceil(item.no_of_book_distributed), // Round up the Harinaam Sankirtan Count
        })
      );
    } else if (
      !bookwisezone &&
      selectedFinancialYear &&
      filterBy === "bookwise" &&
      !zone &&
      !states &&
      !categoryandzone
    ) {
      filteredData = financialAndEventsBookWiseAllData.map((item, index) => ({
        Ranking: index + 1,
        "Book Name": item.book_id,
        "Harinaam Sankirtan Count": Math.ceil(item.total_books), // Round up the Harinaam Sankirtan Count
      }));
    } else if (
      selectedFinancialYear &&
      filterBy === "zone" &&
      !zone &&
      !states &&
      !categoryandzone
    ) {
      filteredData = financialAndEventsZoneAllData.map((item, index) => ({
        Ranking: index + 1,
        Zone: item.zone_id,
        "Harinaam Sankirtan Count": Math.ceil(item.total_books), // Round up the Harinaam Sankirtan Count
      }));
    } else if (templecategory && filterBy !== "bookwise" && !categoryandzone) {
      filteredData = TempleWiseDataBasedonFEZ.map((item, index) => ({
        Ranking: index + 1,
        Particular: item.temple_name,
        Category: item.temple,
        Zone: item.zone,
        "Harinaam Sankirtan Count": Math.ceil(item.no_of_book_distributed), // Round up the Harinaam Sankirtan Count
      }));
    } else if (
      selectedFinancialYear &&
      filterBy === "state" &&
      !states &&
      !categoryandzone
    ) {
      filteredData = financialAndEventsStateAllData.map((item, index) => ({
        Ranking: index + 1,
        State: item.state_name,
        "Harinaam Sankirtan Count": Math.ceil(item.total_books), // Round up the Harinaam Sankirtan Count
      }));
    } else if (
      !states &&
      selectedFinancialYear &&
      filterBy === "temple" &&
      !category &&
      !categoryandzone
    ) {
      filteredData = financialAndEventsTempleAllData.map((item, index) => ({
        Ranking: index + 1,
        Particular: item.temple_id,
        "Harinaam Sankirtan Count": Math.ceil(item.total_books), // Round up the Harinaam Sankirtan Count
      }));
    } else if (
      selectedFinancialYear &&
      bookwisezone &&
      bookwisetemple &&
      !categoryandzone
    ) {
      filteredData = allDataBookWiseWithZoneandTemple.map((item, index) => ({
        Ranking: index + 1,
        "Book Name": item.book_id,
        "Harinaam Sankirtan Count": Math.ceil(item.total_books), // Round up the Harinaam Sankirtan Count
      }));
    } else if (
      !bookwisetemple &&
      filterBy !== "state" &&
      selectedFinancialYear &&
      bookwisezone &&
      !categoryandzone
    ) {
      filteredData = allDataBookWiseWithZone.map((item, index) => ({
        Ranking: index + 1,
        "Book Name": item.book_id,
        "Harinaam Sankirtan Count": Math.ceil(item.total_books), // Round up the Harinaam Sankirtan Count
      }));
    } else if (
      !bookwisetemple &&
      filterBy !== "state" &&
      selectedFinancialYear &&
      bookwisezone &&
      !categoryandzone
    ) {
      filteredData = financialAndEventsZoneAllData.map((item, index) => ({
        Ranking: index + 1,
        "Book Name": item.book_id,
        "Harinaam Sankirtan Count": Math.ceil(item.total_books), // Round up the Harinaam Sankirtan Count
      }));
    } else if (categoryandzone) {
      filteredData = allDataFYECandZone.map((item, index) => ({
        Ranking: index + 1,
        Particular: item.temple_name,
        Category: item.temple,
        Zone: item.zone,
        "Harinaam Sankirtan Count": Math.ceil(item.no_of_book_distributed), // Round up the Harinaam Sankirtan Count
      }));
    } else if (states && !categoryandzone) {
      filteredData = financialAndEventsSelectedStateAllData.map(
        (item, index) => ({
          Ranking: index + 1,
          Particular: item.temple_name,
          Category: item.temple,
          Zone: item.zone,
          "Harinaam Sankirtan Count": Math.ceil(item.no_of_book_distributed), // Round up the Harinaam Sankirtan Count
        })
      );
    } else if (category && filterBy !== "state" && !categoryandzone) {
      filteredData = financialAndEventsSelectedTempleAllData.map(
        (item, index) => ({
          Ranking: index + 1,
          Particular: item.temple_name,
          Category: item.temple,
          Zone: item.zone,
          "Harinaam Sankirtan Count": Math.ceil(item.no_of_book_distributed), // Round up the Harinaam Sankirtan Count
        })
      );
    } else {
      filteredData = financialAllData.map((item, index) => ({
        Ranking: index + 1,
        Particular: item.temple_name,
        Category: item.temple,
        Zone: item.zone,
        "Harinaam Sankirtan Count": Math.ceil(item.no_of_book_distributed), // Round up the Harinaam Sankirtan Count
      }));
    }

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert the filtered data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(filteredData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Book Distribution Data");

    // Create a file name
    const fileName = "live_ranking.xlsx";

    // Write the workbook to a file
    XLSX.writeFile(workbook, fileName);
  };

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    return month >= 4 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
  };
  const fetchDataFromAllLiveRankingByUserId = async (user) => {
    try {
      let res;

      if (user) {
        res = await ApiService.fetchDataFromAllLiveRankingByUserId(
          user.temple_id,
          user.zone_name,
          user.temple,
          user.state_id,
          selectedEvent == ""
            ? "Regular Update"
            : selectedEvent == "Regular Update"
            ? "Live Regular Update"
            : selectedEvent
        );
        setUserScoreData(res);
      } else {
        throw new Error("User ID is required");
      }

      setDataFromAllLiveRankinguserId(res);
    } catch (error) {
      console.log(error);
    }
  };
  const openModal = () => {
    setModalIsOpen(true);
  };
  const closeModal = () => {
    setModalIsOpen(false);
    setShowDropdown(false);
    setSelectedTemple("");
    setSelectedTemples("");
    setComparisonData(null);
    setDataArrays("");
  };

  const fetchDataFromAPI = async ({ temple: value, data }) => {
    // console.log("temple", value);
    const dataObj =
      data.length > 0 ? data?.filter((item) => item.temple_id == value)[0] : {};
    if (value) {
      return [
        `${dataObj?.temple_name || ""}`,
        `${dataObj?.zone || ""}`,
        `${dataObj?.temple || ""}`,
        `${dataObj?.all_rank || ""}`,
        `${dataObj?.zone_rank || ""}`,
        `${dataObj?.temple_rank || ""}`,
        `${dataObj?.state_id_rank || ""}`,
        `${
          isNaN(Math.round(dataObj?.score))
            ? ""
            : Math.round(dataObj?.score).toLocaleString("en-IN")
        }`,
        `${
          isNaN(Math.round(dataObj?.no_of_book_distributed))
            ? ""
            : Math.round(dataObj?.no_of_book_distributed).toLocaleString(
                "en-IN"
              )
        }`,

        `${
          isNaN(Math.round(dataObj?.book_counts?.ChaitanyaCharitamritaSet))
            ? ""
            : Math.round(
                dataObj?.book_counts?.ChaitanyaCharitamritaSet
              ).toLocaleString("en-IN")
        }`,
        `${
          isNaN(Math.round(dataObj?.book_counts?.SrimadBhagavatamSet))
            ? ""
            : Math.round(
                dataObj?.book_counts?.SrimadBhagavatamSet
              ).toLocaleString("en-IN")
        }`,

        `${
          isNaN(Math.round(dataObj?.book_counts?.MahabigBooks))
            ? ""
            : Math.round(dataObj?.book_counts?.MahabigBooks).toLocaleString(
                "en-IN"
              )
        }`,
        `${
          isNaN(Math.round(dataObj?.book_counts?.BigBooks))
            ? ""
            : Math.round(dataObj?.book_counts?.BigBooks).toLocaleString("en-IN")
        }`,
        `${
          isNaN(Math.round(dataObj?.book_counts?.MediumBooks))
            ? ""
            : Math.round(dataObj?.book_counts?.MediumBooks).toLocaleString(
                "en-IN"
              )
        }`,
        `${
          isNaN(Math.round(dataObj?.book_counts?.SmallBooks))
            ? ""
            : Math.round(dataObj?.book_counts?.SmallBooks).toLocaleString(
                "en-IN"
              )
        }`,
        `${
          isNaN(Math.round(dataObj?.book_counts?.SrilaPrabhupadaLilamrita))
            ? ""
            : Math.round(
                dataObj?.book_counts?.SrilaPrabhupadaLilamrita
              ).toLocaleString("en-IN")
        }`,
        `${
          isNaN(Math.round(dataObj?.book_counts?.Magazines))
            ? ""
            : Math.round(dataObj?.book_counts?.Magazines).toLocaleString(
                "en-IN"
              )
        }`,
        `${
          isNaN(Math.round(dataObj?.book_counts?.["1 Year BTG Subscription-1"]))
            ? ""
            : Math.round(
                dataObj?.book_counts?.["1 Year BTG Subscription-1"]
              ).toLocaleString("en-IN")
        }`,
        `${
          isNaN(Math.round(dataObj?.book_counts?.["1 Year BTG Subscription-2"]))
            ? ""
            : Math.round(
                dataObj?.book_counts?.["1 Year BTG Subscription-2"]
              ).toLocaleString("en-IN")
        }`,

        ,
      ];
    }
  };

  const fetchZoneWiseTotalScores = async () => {
    try {
      let res;

      if (user) {
        res = await ApiService.fetchZoneWiseTotalScores();
        setUserScoreData(res);
      } else {
        throw new Error("Zone Wise is required");
      }

      setDataFromDBZoneWise(res);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchTempleWiseTotalScores = async () => {
    try {
      let res;

      if (user) {
        res = await ApiService.fetchTempleWiseTotalScores();
        // setUserScoreData(res);
        // console.log("rereeeerrr", res)
      } else {
        throw new Error("Temple Wise is required");
      }

      setDataFromDBTempleWise(res);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchFinancialYear = async () => {
    try {
      const res = await ApiService.fetchFinancialYear();

      setFinancialYearFromDB(res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDataFromByDefaulFinancialY = async (selectedFinancialYear) => {
    try {
      const res = await ApiService.fetchDataFromByDefaulFinancialY(
        selectedFinancialYear
      );

      setFinancialAllData(res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDataByFinancialandEvents = async (
    selectedFinancialYear,
    selectedEvent
  ) => {
    try {
      const res = await ApiService.fetchDataByFinancialandEvents(
        selectedFinancialYear,
        selectedEvent
      );

      setFinancialandEventsAllData(res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDataByFyearEventZone = async (
    selectedFinancialYear,
    selectedEvent,
    filterBy
  ) => {
    // console.log("sameupdate", selectedFinancialYear, selectedEvent, filterBy)
    try {
      let res;

      if (filterBy === "zone") {
        res = await ApiService.fetchDataByFyearEventZone(
          selectedFinancialYear,
          selectedEvent,
          filterBy
        );
        setFinancialandEventsZoneAllData(res);
      } else if (filterBy === "temple") {
        res = await ApiService.fetchDataByFyearEventTemple(
          selectedFinancialYear,
          selectedEvent,
          filterBy
        );
        setFinancialandEventsTempleAllData(res);
      } else if (filterBy === "bookwise") {
        res = await ApiService.fetchDataByFyearEventBookWise(
          selectedFinancialYear,
          selectedEvent,
          filterBy
        );
        setFinancialandEventsBookWiseAllData(res);
      } else if (filterBy === "state") {
        res = await ApiService.fetchDataByFyearEventState(
          selectedFinancialYear,
          selectedEvent,
          filterBy
        );
        setFinancialandEventsStateAllData(res);
      } else {
        console.log(`Unsupported filterBy value: ${filterBy}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDataByFyearEventZoneandSelected = async (
    selectedFinancialYear,
    selectedEvent,
    filterBy,
    zone
  ) => {
    try {
      const res = await ApiService.fetchDataByFyearEventZoneandSelected(
        selectedFinancialYear,
        selectedEvent,
        filterBy,
        zone
      );

      setFinancialandEventsSelectedZoneAllData(res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDataBOnFSEvtSzoneforTempleWise = async (
    selectedFinancialYear,
    selectedEvent,
    filterBy,
    zone,
    templecategory
  ) => {
    try {
      const res = await ApiService.fetchDataBOnFSEvtSzoneforTempleWise(
        selectedFinancialYear,
        selectedEvent,
        filterBy,
        zone,
        templecategory
      );

      setTempleWiseDataBasedonFEZ(res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDataByFyearEventTempleandSelected = async (
    selectedFinancialYear,
    selectedEvent,
    filterBy,
    category
  ) => {
    try {
      const res = await ApiService.fetchDataByFyearEventTempleandSelected(
        selectedFinancialYear,
        selectedEvent,
        filterBy,
        category
      );

      setFinancialandEventsSelectedTempleAllData(res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDataByFyearEventStateandSelected = async (
    selectedFinancialYear,
    selectedEvent,
    filterBy,
    states
  ) => {
    try {
      const res = await ApiService.fetchDataByFyearEventStateandSelected(
        selectedFinancialYear,
        selectedEvent,
        filterBy,
        states
      );

      setFinancialandEventsSelectedStateAllData(res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDataBookWiseWithZone = async (
    selectedFinancialYear,
    selectedEvent,
    filterBy,
    bookwisezone
  ) => {
    try {
      const res = await ApiService.fetchDataBookWiseWithZone(
        selectedFinancialYear,
        selectedEvent,
        filterBy,
        bookwisezone
      );

      setAllDataBookWiseWithZone(res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDataBookWiseWithZoneAndTemple = async (
    selectedFinancialYear,
    selectedEvent,
    filterBy,
    bookwisezone,
    bookwisetemple
  ) => {
    try {
      const res = await ApiService.fetchDataBookWiseWithZoneAndTemple(
        selectedFinancialYear,
        selectedEvent,
        filterBy,
        bookwisezone,
        bookwisetemple
      );

      setAllDataBookWiseWithZoneandTemple(res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDataWithYECAndZone = async (
    selectedFinancialYear,
    selectedEvent,
    filterBy,
    category,
    categoryandzone
  ) => {
    try {
      const res = await ApiService.fetchDataWithYECAndZone(
        selectedFinancialYear,
        selectedEvent,
        filterBy,
        category,
        categoryandzone
      );

      setAllDataWithFYECandZone(res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // console.log("selectedEventbased", selectedFinancialYear, selectedEvent, filterBy, zone, templecategory)
    fetchDataWithYECAndZone(
      selectedFinancialYear,
      selectedEvent,
      filterBy,
      category,
      categoryandzone
    );
  }, [
    selectedFinancialYear,
    selectedEvent,
    filterBy,
    category,
    categoryandzone,
  ]);

  useEffect(() => {
    // console.log("selectedEventbased", selectedFinancialYear, selectedEvent, filterBy, zone, templecategory)
    fetchDataBookWiseWithZoneAndTemple(
      selectedFinancialYear,
      selectedEvent,
      filterBy,
      bookwisezone,
      bookwisetemple
    );
  }, [
    selectedFinancialYear,
    selectedEvent,
    filterBy,
    bookwisezone,
    bookwisetemple,
  ]);
  useEffect(() => {
    // console.log("selectedEventbased", selectedFinancialYear, selectedEvent, filterBy, zone, templecategory)
    fetchDataBookWiseWithZone(
      selectedFinancialYear,
      selectedEvent,
      filterBy,
      bookwisezone
    );
  }, [selectedFinancialYear, selectedEvent, filterBy, bookwisezone]);

  useEffect(() => {
    // console.log("selectedEventbased", selectedFinancialYear, selectedEvent, filterBy, zone, templecategory)
    fetchDataBOnFSEvtSzoneforTempleWise(
      selectedFinancialYear,
      selectedEvent,
      filterBy,
      zone,
      templecategory
    );
  }, [selectedFinancialYear, selectedEvent, filterBy, zone, templecategory]);

  useEffect(() => {
    // console.log("selectedstate", selectedFinancialYear, selectedEvent, filterBy, states)
    fetchDataByFyearEventStateandSelected(
      selectedFinancialYear,
      selectedEvent,
      filterBy,
      states
    );
  }, [selectedFinancialYear, selectedEvent, filterBy, states]);

  useEffect(() => {
    // console.log("selectedEventbased", selectedFinancialYear, selectedEvent, filterBy, category)
    fetchDataByFyearEventTempleandSelected(
      selectedFinancialYear,
      selectedEvent,
      filterBy,
      category
    );
  }, [selectedFinancialYear, selectedEvent, filterBy, category]);

  useEffect(() => {
    // console.log("selectedEventbased", selectedFinancialYear, selectedEvent, filterBy, zone)
    fetchDataByFyearEventZoneandSelected(
      selectedFinancialYear,
      selectedEvent,
      filterBy,
      zone
    );
  }, [selectedFinancialYear, selectedEvent, filterBy, zone]);

  useEffect(() => {
    // console.log("selectedEventbased", selectedFinancialYear, selectedEvent, filterBy)
    fetchDataByFyearEventZone(selectedFinancialYear, selectedEvent, filterBy);
  }, [selectedFinancialYear, selectedEvent, filterBy]);

  useEffect(() => {
    // console.log("selectedEventbased", selectedFinancialYear, selectedEvent)
    fetchDataByFinancialandEvents(selectedFinancialYear, selectedEvent);
  }, [selectedFinancialYear, selectedEvent]);

  useEffect(() => {
    // console.log("financial_year", selectedFinancialYear)
    fetchDataFromByDefaulFinancialY(selectedFinancialYear);
  }, [selectedFinancialYear]);

  useEffect(() => {
    setSelectedFinancialYear(currentYear); // Ensure it updates to the current year on mount
  }, [currentYear]);

  useEffect(() => {
    fetchFinancialYear();
  }, []);

  useEffect(() => {
    fetchTempleWiseTotalScores();
  }, []);

  useEffect(() => {
    fetchZoneWiseTotalScores();
  }, []);

  useEffect(() => {
    fetchDataFromAllLiveRankingByUserId(user);
  }, [user, selectedEvent]);

  const resetFilters = () => {
    setFilterBy("");
    setCategory("");
    setTempleCategory("");
    setSelectedFinancialYear(currentYear);
    setStates("");
    setZones("");
    setSelectedEvent("");
    setSelectedDate(new Date());
  };

  return (
    <div className="container common-container update-responsive live-ranking live-ranking-table">
      <div className="update-score-container">
        <div className="row">
          <div
            className={
              user.role != "GBC (Governing Body Commission)" &&
              user.role != "Regional Zonal Secretary" &&
              user.role != "Regional Secretary Assistant"
                ? "col-12 col-md-5"
                : "col-12"
            }
          >
            <div className="card card-shadow" style={{ height: "135px" }}>
              <div className="card-body">
                <h5 className="card-title">{t("Live Ranking")}</h5>
                <p className="card-text">
                  {t(
                    "Track your live ranking to see how your Harinam Sankirtan efforts support the collective mission."
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-7">
            {user.role !== "GBC (Governing Body Commission)" &&
              user.role != "Regional Zonal Secretary" &&
              user.role !== "Regional Secretary Assistant" && (
                <div className="card card-shadow" style={{ height: "135px" }}>
                  <div className="card-body">
                    <h5 className="stats-header">
                      <svg width="28" height="28" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path opacity="0.5" d="M27 0C29.2091 0 31 1.79086 31 4V27C31 29.2091 29.2091 31 27 31H4C1.79086 31 0 29.2091 0 27V4C0 1.79086 1.79086 0 4 0H27Z" fill="white" />
                      <path d="M9.87303 21.1259H21.9286C22.3725 21.1259 22.7323 21.4858 22.7323 21.9296C22.7323 22.3735 22.3725 22.7333 21.9286 22.7333H9.06933C8.62546 22.7333 8.26562 22.3735 8.26562 21.9296V9.07037C8.26562 8.6265 8.62546 8.26667 9.06933 8.26667C9.5132 8.26667 9.87303 8.6265 9.87303 9.07037V21.1259Z" fill="#FF968C" />
                      <path d="M12.871 17.6571C12.5674 17.9809 12.0588 17.9973 11.735 17.6938C11.4112 17.3902 11.3947 16.8816 11.6983 16.5577L14.7122 13.3429C15.0058 13.0297 15.4937 13.0026 15.8203 13.2812L18.199 15.3111L21.2983 11.3853C21.5733 11.0369 22.0787 10.9775 22.4271 11.2525C22.7755 11.5276 22.835 12.033 22.5599 12.3814L18.9433 16.9625C18.6608 17.3203 18.1375 17.3718 17.7907 17.0758L15.3603 15.0018L12.871 17.6571Z" fill="#FF968C" />
                    </svg>
                      &nbsp; {t("Your Stats")}
                    </h5>
                    <div className="card-text stats">
                      <div className="text-center">
                        <p className="ranking-status-text mb-2" style={{color:"#1E1F21"}}>
                          {t("All India Rank")}
                        </p>
                        <span className="ranking-count">
                          {userScoreData.all_rank ?? "-"}
                        </span>
                      </div>
                      <div className="text-center">
                        <p className="ranking-status-text mb-2" style={{color:"#1E1F21"}}>
                          {t("State Rank")}
                        </p>
                        <span className="ranking-count">
                          {userScoreData.state_rank ?? "-"}
                        </span>
                      </div>
                      <div className="text-center">
                        <p className="ranking-status-text mb-2" style={{color:"#1E1F21"}}>
                          {t("Zonal Rank")}
                        </p>
                        <span className="ranking-count">
                          {userScoreData.zone_rank ?? "-"}
                        </span>
                      </div>
                      <div className="text-center">
                        <p className="ranking-status-text mb-2" style={{color:"#1E1F21"}}>
                          {t("Total Points")}
                        </p>
                        <span className="ranking-count">
                          {userScoreData?.points
                            ? Math.ceil(
                                userScoreData?.points
                              )?.toLocaleString("en-IN")
                            : "-"}
                        </span>
                      </div>
                      <div className="text-center">
                        <p className="ranking-status-text mb-2" style={{color:"#1E1F21"}}>
                          {t("Harinaam Sankirtan Count")}
                        </p>
                        <span className="ranking-count">
                          {userScoreData?.count_book
                            ? Math.ceil(
                                userScoreData?.count_book
                              )?.toLocaleString("en-IN")
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
        {/* Filters Section */}
        <div className="container mt-3 mt-md-0">
          <div className="row mt-4 filters-wrap">
            <div className="col-12 col-md-10 filter-container p-0 event-filter" style={{backgroundColor: "#FFF2EB"}}>
              <div
                style={{
                  width: "180px",
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  textAlign: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  getAllLiveDownload();
                }}
              >
                {t("Download")}
              </div>

              <span className="filter-border"></span>
              <p
                className="filter-text fordrop-down"
                style={{
                  width: "180px",
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  textAlignz: "center",
                }}
              >
                {t("Filter By")}
              </p>

              <span className="filter-border"></span>
              <select
                className="form-select text-center"
                value={selectedFinancialYear} // Update to selectedFinancialYear
                onChange={(e) => setSelectedFinancialYear(e.target.value)} // Update to setSelectedFinancialYear
                style={{backgroundColor: "#FFF2EB"}}
              >
                {financialYearArray.map((option) => (
                  <option key={option.id} value={option.financial_year}>
                    {option.financial_year}
                  </option>
                ))}
              </select>
              <span className="filter-border"></span>

              <select
                className="form-select text-center"
                value={filterBy}
                onChange={(e) => {
                  setFilterBy(e.target.value);
                  // setZonewise(e.target.value);
                  if (e.target.value != "zone") {
                    setIsSubZone(true);
                    setZones("");
                  } else {
                    setIsSubZone(false);
                    // setIsSubTemple(false)
                  }
                }}
                style={{backgroundColor: "#FFF2EB"}}
                aria-label="Filter By"
              >
                <option value="" className="filter-text">
                  {t("All India Ranking")}
                </option>
                <option value="zone" className="filter-text">
                  {t("Zone Wise")}
                </option>
                <option value="temple" className="filter-text">
                  {t("Category Wise")}
                </option>
                <option value="state" className="filter-text">
                  {t("State Wise")}
                </option>
              </select>
              <span className="filter-border"></span>
              {/* Conditionally Render Category Dropdown */}
              {filterBy === "temple" && (
                <>
                  <select
                    className="form-select"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    aria-label="Category"
                  >
                    <option value="" className="filter-text">
                      {t("Select Category")}
                    </option>
                    {categories.map((cat, index) => (
                      <option key={index} value={cat} className="filter-text">
                        {t(cat)}
                      </option>
                    ))}
                  </select>
                  <span className="filter-border"></span>
                </>
              )}
              {category && (
                <>
                  <select
                    className="form-select"
                    value={categoryandzone}
                    onChange={(e) => {
                      setZonetTemple(e.target.value);
                      // setSubZone(""); // Reset subZone when a new zone is selected
                    }}
                    aria-label="Zone"
                  >
                    <option value="" className="filter-text text-center">
                      {t("Select Zone")}
                    </option>
                    {zones.map((zon, index) => (
                      <option
                        key={index}
                        value={zon}
                        className="filter-text text-center"
                      >
                        {t(zon)}
                      </option>
                    ))}
                  </select>
                  <span className="filter-border"></span>
                </>
              )}
              {filterBy === "state" && (
                <>
                  <select
                    className="form-select"
                    value={states}
                    onChange={(e) => setStates(e.target.value)}
                    aria-label="Category"
                  >
                    <option value="" className="filter-text">
                      {t("Select State")}
                    </option>
                    {statesOfIndia.map((sat, index) => (
                      <option key={index} value={sat} className="filter-text">
                        {t(sat)}
                      </option>
                    ))}
                  </select>
                  <span className="filter-border"></span>
                </>
              )}

              {filterBy === "zone" && (
                <>
                  <select
                    className="form-select"
                    value={zone}
                    onChange={(e) => {
                      setZones(e.target.value);
                      // setIsSubZone(true)
                    }}
                    aria-label="Category"
                  >
                    <option value="" className="filter-text text-center">
                      {t("Select Zone")}
                    </option>
                    {zones.map((zon, index) => (
                      <option
                        key={index}
                        value={zon}
                        className="filter-text text-center"
                      >
                        {t(zon)}
                      </option>
                    ))}
                  </select>
                  <span className="filter-border"></span>

                  {/* Conditionally Render Temple Category Dropdown */}
                  {[
                    "East Zone",
                    "West Zone",
                    "North Zone",
                    "South Zone",
                  ].includes(zone) && (
                    <>
                      <select
                        className="form-select"
                        value={templecategory}
                        onChange={(e) => setTempleCategory(e.target.value)}
                        aria-label="Temple Category"
                      >
                        <option value="" className="filter-text">
                          {t("Select Category")}
                        </option>
                        {templeCategories.map((cat, index) => (
                          <option
                            key={index}
                            value={cat.id}
                            className="filter-text"
                          >
                            {t(cat.name)}
                          </option>
                        ))}
                      </select>
                      <span className="filter-border"></span>
                    </>
                  )}
                </>
              )}
              {/* Phone Views */}
              <div
                className="d-flex align-items-center justify-content-center filter-by d-md-none"
                style={{ cursor: "pointer", padding: "8px" }}
                onClick={resetFilters}
              >
                {/* Compare Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#9F1D21"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17 1l4 4-4 4" />
                  <path d="M21 5H9a4 4 0 0 0-4 4v12" />
                  <path d="M7 23l-4-4 4-4" />
                  <path d="M3 19h12a4 4 0 0 0 4-4V3" />
                </svg>

                {/* Label */}
                <p
                  className="filter-text reset-live-filters ms-2"
                  style={{ textAlign: "center", margin: 0 }}
                >
                  {t("Reset Filter")}
                </p>
              </div>
              {/* Phone View */}
            </div>
            <div className="col-12 col-md-2 d-flex align-items-center justify-content-end p-0 d-none d-md-flex">
              <button
                type="button"
                className="custom-compare-btn"
                onClick={resetFilters}
              >
                {t("Reset Filter")}
              </button>
            </div>
          </div>
        </div>
        {/* Live Ranking Table */}

        <div className="container mt-4 ">
          {/* Desktop Table View */}

          {filterBy === "" && !categoryandzone && (
            <table className="table custom-table">
              <thead>
                <tr>
                  <th className="table-row-header text-center">
                    {t("Ranking")}
                  </th>
                  <th
                    className="table-row-header text-center"
                    style={{ cursor: "pointer" }}
                    onClick={handleHeaderClickPart}
                  >
                    {t("Particular")}
                    <span className="ms-1">
                      {searchVisiblePart ? (
                        <i className="bi bi-chevron-up"></i>
                      ) : (
                        <i className="bi bi-chevron-down"></i>
                      )}
                    </span>
                  </th>
                  <th
                    className="table-row-header text-center"
                    style={{ cursor: "pointer" }}
                    onClick={handleHeaderClickCat}
                  >
                    {t("Category")}
                    <span className="ms-1">
                      {searchVisibleCat ? (
                        <i className="bi bi-chevron-up"></i>
                      ) : (
                        <i className="bi bi-chevron-down"></i>
                      )}
                    </span>
                  </th>
                  <th
                    className="table-row-header text-center"
                    style={{ cursor: "pointer" }}
                    onClick={handleHeaderClickZone}
                  >
                    {t("Zone")}
                    <span className="ms-1">
                      {searchVisibleZone ? (
                        <i className="bi bi-chevron-up"></i>
                      ) : (
                        <i className="bi bi-chevron-down"></i>
                      )}
                    </span>
                  </th>
                  <th className="table-row-header text-center">
                    {t("Total Points")}
                  </th>
                  <th className="table-row-header text-center">
                    {t("Harinaam Sankirtan Count")}
                  </th>
                </tr>

                {(searchVisiblePart ||
                  searchVisibleCat ||
                  searchVisibleZone) && (
                  <tr>
                    <th></th>
                    <th>
                      {searchVisiblePart && (
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder={t("Search Particular")}
                          onChange={handleSearchChangeTempleName}
                        />
                      )}
                    </th>
                    <th>
                      {searchVisibleCat && (
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder={t("Search Category")}
                          onChange={handleSearchChangeTemple}
                        />
                      )}
                    </th>
                    <th>
                      {searchVisibleZone && (
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder={t("Search Zone")}
                          onChange={handleSearchChangeZone}
                        />
                      )}
                    </th>
                    <th></th>
                  </tr>
                )}
              </thead>

              <tbody>
                {filteredDataForSearch.map((row, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td className="text-center">
                      {i18n.language === "hi"
                        ? row.hindi_temple_name
                        : row.temple_name}
                    </td>
                    <td className="text-center">{t(row.temple)}</td>
                    <td className="text-center">{t(row.zone)}</td>
                    <td className="text-center">
                      {row.score
                        ? row.score.toLocaleString("en-IN")
                        : "-"}
                    </td>
                    <td className="text-center">
                      {row.no_of_book_distributed
                        ? row.no_of_book_distributed.toLocaleString("en-IN")
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="container mt-4">
          {!templecategory && zone && !categoryandzone && (
            <table className="table custom-table">
              <thead>
                <tr>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Ranking")}
                  </th>

                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Particular")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Category")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Zone")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Total Points")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Harinaam Sankirtan Count")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {(zone
                  ? financialAndEventsSelectedZoneAllData
                  : financialAndEventsSelectedZoneAllData
                ).map((row, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: "center" }}>{index + 1}</td>

                    <td style={{ textAlign: "center" }}>
                      {i18n.language === "hi"
                        ? row.hindi_temple_name
                        : row.temple_name}
                    </td>
                    <td style={{ textAlign: "center" }}>{t(row.temple)}</td>
                    <td style={{ textAlign: "center" }}>{t(row.zone)}</td>
                    <td style={{ textAlign: "center" }}>
                      {row.score
                        ? row.score.toLocaleString("en-IN")
                        : "-"}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {row.no_of_book_distributed
                        ? row.no_of_book_distributed.toLocaleString("en-IN")
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="container mt-4">
          {category && filterBy !== "state" && !categoryandzone && (
            <table className="table custom-table">
              <thead>
                <tr>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Ranking")}
                  </th>

                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Particular")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Category")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Zone")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Total Points")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Harinaam Sankirtan Count")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {(category
                  ? financialAndEventsSelectedTempleAllData
                  : financialAndEventsSelectedTempleAllData
                ).map((row, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: "center" }}>{index + 1}</td>

                    <td style={{ textAlign: "center" }}>
                      {i18n.language === "hi"
                        ? row.hindi_temple_name
                        : row.temple_name}
                    </td>
                    <td style={{ textAlign: "center" }}>{t(row.temple)}</td>

                    <td style={{ textAlign: "center" }}>{t(row.zone)}</td>
                    <td style={{ textAlign: "center" }}>
                      {row.score
                        ? row.score.toLocaleString("en-IN")
                        : "-"}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {row.no_of_book_distributed
                        ? row.no_of_book_distributed.toLocaleString("en-IN")
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="container mt-4">
          {states && !categoryandzone && (
            <table className="table custom-table">
              <thead>
                <tr>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Ranking")}
                  </th>

                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Particular")}
                  </th>
                  <th
                    style={{ textAlign: "lecenterft" }}
                    className="table-row-header"
                  >
                    {t("Category")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Zone")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Total Points")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Harinaam Sankirtan Count")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {(states
                  ? financialAndEventsSelectedStateAllData
                  : financialAndEventsSelectedStateAllData
                ).map((row, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: "center" }}>{index + 1}</td>

                    <td style={{ textAlign: "center" }}>
                      {i18n.language === "hi"
                        ? row.hindi_temple_name
                        : row.temple_name}
                    </td>
                    <td style={{ textAlign: "center" }}>{t(row.temple)}</td>
                    <td style={{ textAlign: "center" }}>{t(row.zone)}</td>
                    <td style={{ textAlign: "center" }}>
                      {row.score
                        ? row.score.toLocaleString("en-IN")
                        : "-"}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {row.no_of_book_distributed
                        ? row.no_of_book_distributed.toLocaleString("en-IN")
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {selectedFinancialYear &&
          filterBy === "zone" &&
          !zone &&
          !states &&
          !categoryandzone && (
            <div className="container mt-4">
              <table className="table custom-table">
                <thead>
                  <tr>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Ranking")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Zone")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Total Points")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Harinaam Sankirtan Count")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {financialAndEventsZoneAllData.map((row, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>{index + 1}</td>
                      <td style={{ textAlign: "center" }}>{t(row.zone_id)}</td>
                      <td style={{ textAlign: "center" }}>
                        {row.total_score.toLocaleString("en-IN")}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {row.total_books.toLocaleString("en-IN")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        {/* Book Wise Data Fetch Start */}
        {!bookwisezone &&
          selectedFinancialYear &&
          filterBy === "bookwise" &&
          !zone &&
          !states &&
          !categoryandzone && (
            <div className="container mt-4">
              <table className="table custom-table">
                <thead>
                  <tr>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Ranking")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Book Name")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Total Points")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Harinaam Sankirtan Count")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {financialAndEventsBookWiseAllData.map((row, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>{index + 1}</td>
                      <td style={{ textAlign: "center" }}>
                        {t(bookIdMapping[row.book_id] || row.book_id)}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {row.total_score.toLocaleString("en-IN")}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {row.total_books.toLocaleString("en-IN")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        {!bookwisetemple &&
          filterBy !== "state" &&
          selectedFinancialYear &&
          bookwisezone &&
          !categoryandzone && (
            <div className="container mt-4">
              <table className="table custom-table">
                <thead>
                  <tr>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Ranking")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Book Name")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Total Points")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Harinaam Sankirtan Count")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allDataBookWiseWithZone.map((row, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>{index + 1}</td>
                      <td style={{ textAlign: "center" }}>
                        {t(bookIdMapping[row.book_id] || row.book_id)}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {row.total_score.toLocaleString("en-IN")}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {row.total_books.toLocaleString("en-IN")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        {selectedFinancialYear &&
          bookwisezone &&
          bookwisetemple &&
          !categoryandzone && (
            <div className="container mt-4">
              <table className="table custom-table">
                <thead>
                  <tr>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Ranking")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Book Name")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Total Points")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Harinaam Sankirtan Count")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allDataBookWiseWithZoneandTemple.map((row, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>{index + 1}</td>
                      <td style={{ textAlign: "center" }}>
                        {t(bookIdMapping[row.book_id] || row.book_id)}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {row.total_score.toLocaleString("en-IN")}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {row.total_books.toLocaleString("en-IN")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        {/* Book Wise Data Fetch End */}

        {!states &&
          selectedFinancialYear &&
          filterBy === "temple" &&
          !category &&
          !categoryandzone && (
            <div className="container mt-4">
              <table className="table custom-table">
                <thead>
                  <tr>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Ranking")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Particular")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Total Points")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Harinaam Sankirtan Count")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {financialAndEventsTempleAllData.map((row, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>{index + 1}</td>
                      <td style={{ textAlign: "center" }}>
                        {t(row.temple_id)}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {row.total_score.toLocaleString("en-IN")}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {row.total_books.toLocaleString("en-IN")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        {selectedFinancialYear &&
          filterBy === "state" &&
          !states &&
          !categoryandzone && (
            <div className="container mt-4">
              <table className="table custom-table">
                <thead>
                  <tr>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Ranking")}
                    </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("State")}
                    </th>
                    <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Total Points")}
                  </th>
                    <th
                      style={{ textAlign: "center" }}
                      className="table-row-header"
                    >
                      {t("Harinaam Sankirtan Count")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {financialAndEventsStateAllData.map((row, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>{index + 1}</td>
                      <td style={{ textAlign: "center" }}>
                        {t(row.state_name)}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {row.total_score.toLocaleString("en-IN")}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {row.total_books.toLocaleString("en-IN")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        <div className="container mt-4">
          {templecategory && filterBy !== "bookwise" && !categoryandzone && (
            <table className="table custom-table">
              <thead>
                <tr>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Ranking")}
                  </th>

                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Particular")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Category")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Zone")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Total Points")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Harinaam Sankirtan Count")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {(templecategory
                  ? TempleWiseDataBasedonFEZ
                  : TempleWiseDataBasedonFEZ
                ).map((row, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: "center" }}>{index + 1}</td>

                    <td style={{ textAlign: "center" }}>
                      {i18n.language === "hi"
                        ? row.hindi_temple_name
                        : row.temple_name}
                    </td>
                    <td style={{ textAlign: "center" }}>{t(row.temple)}</td>
                    <td style={{ textAlign: "center" }}>{t(row.zone)}</td>
                    <td style={{ textAlign: "center" }}>
                      {row.score
                        ? row.score.toLocaleString("en-IN")
                        : "-"}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {row.no_of_book_distributed
                        ? row.no_of_book_distributed.toLocaleString("en-IN")
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="container mt-4">
          {categoryandzone && (
            <table className="table custom-table mt-4">
              <thead>
                <tr>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Ranking")}
                  </th>

                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Particular")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Category")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Zone")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Total Points")}
                  </th>
                  <th
                    style={{ textAlign: "center" }}
                    className="table-row-header"
                  >
                    {t("Harinaam Sankirtan Count")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {allDataFYECandZone.map((row, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: "center" }}>{index + 1}</td>

                    <td style={{ textAlign: "center" }}>
                      {i18n.language === "hi"
                        ? row.hindi_temple_name
                        : row.temple_name}
                    </td>
                    <td style={{ textAlign: "center" }}>{t(row.temple)}</td>
                    <td style={{ textAlign: "center" }}>{t(row.zone)}</td>
                    <td style={{ textAlign: "center" }}>
                      {row.score
                        ? row.score.toLocaleString("en-IN")
                        : "-"}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {row.no_of_book_distributed
                        ? row.no_of_book_distributed.toLocaleString("en-IN")
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default LiveRankingData;
